import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from '../services/api.service';
import { HubService } from '../services/hub.service';
import { ProfileService } from '../services/profile.service';
import { UserProfile } from '../types/user-profile';

@Component({
  selector: 'profiles',
  template: `<div class="profiles" *ngIf="CanAdminister(); else notAdmin">
  <admin-sub-menu></admin-sub-menu>
  <div *ngFor="let profile of profiles"
       class="profile_row"
      [class.selected]="profile === currentProfile"
      [style.background-color]="this.getColorFor(profile)"
      (click)="gotoDetail(profile)">
    <div class="badge" *ngIf="!!profile.social && !!profile.social.picture"><img src="{{profile.social.picture}}"></div>
    <div class="details">
      <div id="names">
      <span class="name">{{profile.social.name}}</span><br>
      <span class="email">{{profile.social.email}}</span>
      </div>
      <div id="rights">
        <span *ngIf="!!profile.administer">administrator</span>
        <span *ngIf="!!profile.rights['address']">view addresses</span>
        <span *ngIf="!!profile.rights['firmware']">release firmware</span>
      </div>
    </div>
  </div>
</div>
<ng-template #notAdmin>Not an administrator.</ng-template>
`,
  styles: [`.profiles { margin: 0 0 2em 0; padding: 0; min-width: 23em; width: 100%; }`,
    `.profile_row { cursor: pointer; position: relative; padding: 0; margin: 0.5em 0.1em;
              min-height: 64px; line-height: 2.8em; min-width: 23em; width: 100%; }`,
    `.profile_row:hover { color: #607D8B; background-color: #DDD; }`,
    `.selected { background-color: #CFD8DC !important; color: white; }`,
    `.profile_row .selected:hover { background-color: #BBD8DC !important; color: white; }`,
    `.profile_row .badge { display: inline-block; font-size: small; color: white; float: left;
              background-color: #607D8B; padding: 0; top: 0; height: 64px; width: 64px; }`,
    `.profile_row .badge img { display: inline-block; height: 64px; width: 64px; }`,
    `.profile_row .details { display: inline-block; }`,
    `#names { display: inline-block; vertical-align: middle; padding: 0.1em 0.8em; line-height: 1.1em; height: available; width: 18em;}`,
    `#names span.name { display: inline-block; width: 18em; }`,
    `#names span.email { display: inline-block; width: 18em; }`,
    `#rights { display: inline-block; }`,
    `#rights span { display: inline; }`,
    `#rights span:after { content: ', '; }`,
    `#rights span:last-child:after { content: ''; }`],
  providers: [HubService],
})


export class ProfilesComponent implements OnInit {
  CanAdminister = ProfileService.CanAdminister;
  adding = false;
  profiles: UserProfile[];
  allProfiles: UserProfile[];
  errorMessage: any;

  constructor(
    private profileService: ProfileService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!ApiService.IsLoggedIn()) { return; }
    this.getProfiles();
  }

  getProfiles(): void {
    this.profileService.AllProfiles().subscribe(
      profiles => this.updatedProfiles(profiles),
      error => this.errorMessage = <any>error,
    );
  }

  private updatedProfiles(newProfiles: UserProfile[]): void {
    this.allProfiles = [];
    newProfiles.forEach((user: UserProfile) => {
      if (user.social && user.social.email) {
        user.social.email = user.social.email.replace('@thehubcontroller.com', '@hubcontrols.com');
      }
      if (!user.rights) {
        user.rights = {'address': false, 'firmware': false};
      }
      this.allProfiles.push(user);
    });
    this.profiles = this.allProfiles;
  }

  gotoDetail(user: UserProfile): void {
    this.router.navigate(['/admin/profile/', user.type, user.id]);
  }

  addProfile(): void {
    this.adding = true;
  }

  closeDetail(): void {
    this.adding = false;
    this.getProfiles();
  }

  getColorFor(profile: UserProfile): string {
    if (this.errorMessage) { return '#ff8080'; } // So editor doesn't make me think this can be static
    if (profile.administer) { return '#e0fff0'; }
    return '#EEEEEE';
  }

}

